import React from 'react'
import Texts from 'react-sdk/Texts';
import AppState, { POPUPS, SCREENS } from '../../js/AppState';
import IconButton from '../shared/IconButton/IconButton';
import Dropdown from '../shared/Dropdown/Dropdown';

import button_menu from '../../images/icones/button_menu.png'
import button_fullscreen from '../../images/icones/button_fullscreen.png'
import Button from '../shared/Button/Button';
import { useState } from 'react';
import PresentationHelper from '../../js/PresentationHelper';
import Timeline from './Timeline/Timeline';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import './TopBar.css'

const TopBar = ({pauseAvailable, untabulable=false }) => {

  untabulable = untabulable || AppState.popup || AppState.paused

  const [fullscreen, setFullScreen] = useState(false)

  function handleMenuClick(e) {
    
    if(AppState.popup === null)
      AppState.setPopup(POPUPS.SETTINGS)
    else if(AppState.popup === POPUPS.SETTINGS)
      AppState.setPopup(null)

    e.stopPropagation()
  }

  function handleFullscreenClick(e) {
    if(fullscreen)
    {
      document.exitFullscreen();
    }
    else
    {
      document.documentElement.requestFullscreen();
    }
    setFullScreen(!fullscreen)

    e.stopPropagation()
  }

  return (
    <div className="TopBar">   
      {/* { PresentationHelper.started && <Dropdown currentElement={PresentationHelper.getCurrentTitle()} elements={PresentationHelper.getTitles()} elementSelected={ (id) => PresentationHelper.handleGotToSequence(id) }/> } */}
      { PresentationHelper.started && <Timeline currentIndex={PresentationHelper.currentElementIndex}/> }

      <IconButton className={"topbar " + (AppState.screen === SCREENS.PRESENTATION? " " : "home ") + "fullscreen"} onClick={handleMenuClick} icon={button_menu} />
      <IconButton className={"topbar " + (AppState.screen === SCREENS.PRESENTATION? " " : "home ") + "menu"} onClick={handleFullscreenClick} icon={button_fullscreen} />
      
    </div>
  );
};

export default observer(TopBar)
